import { defineComponent as _defineComponent } from 'vue'
import { Component } from 'vue';
import { TreeItem, TreeType } from '@/components/Layers/modal/types';
import ModalImportLayersTreeItemExternal from './ModalImportLayersTreeItemExternal.vue';
import ModalImportLayersTreeItem from './ModalImportLayersTreeItem.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalImportLayersTree',
  props: {
    treeItem: null
  },
  setup(__props: any) {



const getComponent = (treeItemType: TreeType) => {
    const components: Record<string, Component> = {
        [TreeType.FROM_FILE_ELEMENT]: ModalImportLayersTreeItemExternal,
        ['default']: ModalImportLayersTreeItem
    };
    return components[treeItemType] || components['default'];
};

return { __sfc: true,getComponent }
}

})